import { query } from '@angular/animations'
import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core'
import { ActivatedRoute } from '@angular/router'

@Component({
  selector: 'dmmp-search-head',
  templateUrl: './search-head.component.html',
})
export class SearchHeadComponent implements OnChanges {
  @Input() module: any
  @Input() identifier: string
  @Input() resultTotal: number
  @Input() optionsFilterBy: any
  @Input() optionsOrderBy: any
  @Input() currentCheckboxFilters
  @Output() checkboxFiltersAction = new EventEmitter()
  @Output() selectedFilter = new EventEmitter()
  @Output() selectedOrder = new EventEmitter()
  @Input() isSearching: boolean = false
  titleSearchHead: string
  labelSearch = {
    found: 'Resultados encontrados',
    notFound: 'Lo sentimos, no se ha encontrado',
    filter: 'Filtro',
    tryOtherFound: 'Intenta realizar otra búsqueda.',
    filterBy: 'Filtrar por',
    orderBy: 'Ordenar por',
    filterByAll: 'Todos',
    orderByNoOne: 'Ninguno',
  }

  constructor(private activatedRoute: ActivatedRoute) {}

  ngOnChanges(changes: SimpleChanges): void {
    this.selectedTitle()
  }

  selectedTitle() {
    const filterSize = this.currentCheckboxFilters?.options.length
    const queryString = this.activatedRoute.snapshot.queryParams.q
    const moduleName = this.module.name
    if (moduleName) {
      if (queryString) {
        filterSize === 0
          ? (this.titleSearchHead = queryString)
          : (this.titleSearchHead = moduleName)
      } else if (filterSize === 1) {
        this.titleSearchHead = this.currentCheckboxFilters.options[0].name
      } else if (
        this.resultTotal !== 0 ||
        (this.resultTotal === 0 && !this.isSearching)
      ) {
        this.titleSearchHead = moduleName
      } else {
        this.titleSearchHead = this.labelSearch.notFound
      }
    }
  }
}
